// Theme colors definition - Single source of truth for the application
export interface ThemeColors {
    primary: string
    primaryHover: string
    primaryLight: string
    primaryMedium: string
    primaryDark: string
    primaryDarkest: string
    secondary: string
    secondaryLight: string
    secondaryDark: string
    secondaryDarkest: string
    tertiary: string
    tertiaryHover: string
    success: string
    successHover: string
    warning: string
    danger: string
    dangerHover: string
    info: string
    background: string
    backgroundDark:string
    surface: string
    surfaceHighlight: string
    text: string
    textLight: string
    textLightest: string
    border: string
    borderHover: string
}

// Main color palette
export const APP_COLORS: ThemeColors = {
    // Blue palette
    primary: '#4a90e2',
    primaryHover: '#357ABD',
    primaryLight: '#588891;',
    primaryMedium: '#114F66',
    primaryDark: '#013668',
    primaryDarkest: '#011C36',

    // Gray palette
    secondary: '#6c757d',
    secondaryLight: '#e5e6e8',
    secondaryDark: '#495057',
    secondaryDarkest: '#1b1c1e ',

    // Teal palette
    tertiary: '#17a2b8',
    tertiaryHover: '#138496',

    // Status colors
    success: '#28a745',
    successHover: '#218838',
    warning: '#ffc107',
    danger: '#d32f2f',
    dangerHover: '#b71c1c',
    info: '#17a2b8',

    // UI colors
    background: '#e6f2ff',
    backgroundDark: '#004d99',
    surface: '#ffffff',
    surfaceHighlight: '#f1f5f9',
    text: '#333333',
    textLight: '#6c757d',
    textLightest: '#f8f9fa',
    border: '#dddddd',
    borderHover: '#9ca3af',
}

// Generate CSS variables from the theme colors
export function generateCssVariables(): string {
    let cssVars = ':root {\n'

    Object.entries(APP_COLORS).forEach(([key, value]) => {
        cssVars += `  --color-${key}: ${value};\n`
    });

    cssVars += '}\n'
    return cssVars
}